<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px; padding-left:10px;">
            <el-button type="text">
              终端名称：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.userName"
              placeholder="请输入人员名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="tableList.tableQuery.searchDate" />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
          <el-col
            :span="5"
            style="padding-right: 20px;float: right;text-align:right;"
          >
            <el-button
              type="primary"
              @click="selectItemFun()"
            >
              选择活动绩效
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table2
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :multiple-selection.sync="multipleSelection"
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @selectItem="selectItemFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin2 from '@/mixin/dialogTableCustomMixin2'
// 日期选择
import DateSelect from '@/components/DateSelect'
// API
import { loadSalaryActivityPerformanceInfoListDataApi } from '@/api/v2/salaryActivityPerformanceInfo'

export default {
  name: 'SalaryActivityPerformanceInfoList',
  components: { CustomTable2, DateSelect },
  mixins: [dialogDragMixin, dialogTableCustomMixin2],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'salary_activity_performance_info_list_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'select',
            label: '选择活动绩效',
            method: 'selectItem'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 5000,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          userName: '',
          schemeNo: '',
          searchDate: '',
          status: 1,
          activitySub: 1,
          isPerformance: 1
        }
      },
      multipleSelection: [],
      isPaging: true
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.multipleSelection = []
        _this.tableList.initTableColumn = [
          { prop: 'sellId', label: '报告编号', filterColumn: 'tsapi.sell_id', width: 120 },
          { prop: 'schemeNo', label: '方案编号', filterColumn: 'ts.project_no', width: 200 },
          { prop: 'schemeName', label: '方案名称', filterColumn: 'ts.name', width: 200 },
          { prop: 'activityDate', label: '活动日期', filterColumn: 'tcbs.activity_date', width: 120, isBetween: true },
          { prop: 'feedbackTime', label: '最后审核时间', filterColumn: 'tcbs.feedback_time', width: 150, isBetween: true },
          { prop: 'provinceName', label: '省区', filterColumn: 'tcbs.province_name', width: 120 },
          { prop: 'cityName', label: '城市', filterColumn: 'tcbs.city_name', width: 120 },
          { prop: 'fieldTypeValue', label: '场次', filterColumn: 'tcbs.field_type', filterValue: 'fieldType', filterArray: [{ label: '一场半天', value: 1 }, { label: '一场一天', value: 2 }], width: 120 },
          { prop: 'userName', label: '人员名称', filterColumn: 'tr.name', width: 120 },
          { prop: 'isDisplayValue', label: '是否有展陈', filterColumn: 'tsapi.is_display', filterValue: 'isDisplay', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 160 },
          { prop: 'displayAmount', label: '展陈数量', filterColumn: 'tsapi.display_amount', width: 120 },
          { prop: 'isMonthValue', label: '是否月度人员', filterColumn: 'tsapi.is_month', filterValue: 'isMonth', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 160 },
          { prop: 'performanceAmount', label: '绩效金额', filterColumn: 'tsapi.performance_amount', width: 160 },
          { prop: 'realPerformanceAmount', label: '实发绩效金额', filterColumn: 'tsapi.real_performance_amount', width: 160 },
          { prop: 'deductAmount', label: '绩效扣除金额', filterColumn: 'tsapi.deduct_amount', width: 160 },
          { prop: 'deductDescription', label: '绩效扣除说明', filterColumn: 'tsapi.deduct_description', width: 160 },
          { prop: 'activityWarning', label: '预警信息', filterColumn: 'tsapi.activity_warning', width: 160 },
          { prop: 'remark', label: '备注', filterColumn: 'tsapi.remark', width: 200 }
        ]
        _this.tableList.tableColumns = _this.tableList.initTableColumn
        _this.tableList.tableQuery.userName = ''
        _this.tableList.tableQuery.schemeNo = ''
        _this.searchData(_this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadSalaryActivityPerformanceInfoListDataApi(_this.tableList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(_this.tableList, data.list || []);
        _this.tableList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 选择终端
    selectItemFun () {
      let _this = this;
      if (_this.multipleSelection.length < 1) {
        _this.$message({ message: '请选择活动绩效', type: 'warning' })
        return false
      } else {
        _this.$emit('selectedInfoFun', _this.multipleSelection)
        _this.modalClose()
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
